// Mood Board Color
export const BG_PRIMARY = 'rgba(225,185,158,1)';
export const BG_SECONDARY = 'rgba(255,255,255,1)';

export const ASSETS_PRIMARY = '#e5cc9e';
export const ASSET_BORDER = 'rgba(255,255,255,0.25)';
export const ASSET_BG = 'rgba(255,255,255,0.08)';
export const BG_LAYER = 'rgba(248, 234, 231, 0.4)';

// Text Color
export const TEXT_PRIMARY = '#ffffff'; //brown dark
export const TEXT_SECONDARY = '#fff8ed'; // Title color section
export const TEXT_ALTERNATIVE = '#cd839b'; // Button Text Color

// Music & Navigation Color
export const NAVIGATION_COLOR = ASSETS_PRIMARY; // Warna BG
export const ICON_NAVIGATION_COLOR = 'white'; // Warna Iconnya

// Default Button Color
export const BUTTON_PROPS = {
  _active: { opacity: '.8' },
  _hover: { opacity: '.8' },
  _focus: { opacity: '.8' },
};
